import { Power3,gsap,Back } from "gsap";
import { StageLayer } from "@nolimitcity/slot-launcher/bin/StageLayer";
import { ISequencePlay, Sequence } from "../../../dev/displayobject/Sequence";
import { Helper } from "../../../dev/utils/Helper";
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { SpinePlayConfig, SpinePlayer } from "../../../dev/displayobject/SpinePlayer";
import { TextStyleOptions, BitmapTextStyleOptions } from '../../../dev/setting/text/IText';
import { FontStyle, FontWeight } from '@nolimitcity/slot-launcher/bin/loader/font/FontStatics';
import { GameAssets } from '../../config/texture/GameAssets';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { RoadRage } from '../../RoadRage';
import { BLEND_MODES } from 'pixi.js';
import { MathHelper } from '../../../dev/utils/MathHelper';
import { Translator } from "../../../dev/setting/Translator";
import { TranslationTexts } from "../../config/translate/TranslationTexts";

export interface OverlayItem {
    item: PIXI.DisplayObject;
    timeline: gsap.core.Timeline;
}

export class OverlayAnimation extends PIXI.Container implements StageLayer {

    private readonly _multStyle: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontStyle: FontStyle.ITALIC,
        fontWeight: FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 20,
        fill: [
            "#ffffff",
            "#FFFC00"
        ],
        fontSize: 56,
        miterLimit: 0,
        wordWrap: true,
        wordWrapWidth: 500,
        stroke: "#FF6A00",
        strokeThickness: 4
    };

    private readonly _multStyle_RED: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontStyle: FontStyle.ITALIC,
        fontWeight: FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 20,
        fill: [
            "#FFC4AB",
            "#FF4013"
        ],
        fontSize: 56,
        miterLimit: 0,
        wordWrap: true,
        wordWrapWidth: 500,
        stroke: "#5C0700",
        strokeThickness: 4
    };

    private readonly _multStyle_GREEN: TextStyleOptions = {
        fontFamily: "Helvetica",
        fontStyle: FontStyle.ITALIC,
        fontWeight: FontWeight.EXTRA_BOLD,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 8,
        dropShadowDistance: 20,
        fill: [
            "#ffffff",
            "#00F900"
        ],
        stroke: "#263E0F",
        fontSize: 56,
        miterLimit: 0,
        wordWrap: true,
        wordWrapWidth: 500,
        strokeThickness: 4
    };
    
    private readonly _styleFS: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_FS_NUMBERS,
        fontSize: 26,
    };


    private readonly _style: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_FS_NUMBERS,
        fontSize: 22,
        tint: 0xffffff,
        letterSpacing:0
    };

    private readonly _style_low: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW,
        fontSize: 20,
        letterSpacing: 12
    };

    private readonly _styleWays: TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 7.5,
        fill: "white",
        fontFamily: "Helvetica",
        fontSize: 18,
        fontStyle: "italic",
        fontWeight: "bold",
        miterLimit: 0,
        strokeThickness: 3
    };


    private bgAnim:SpinePlayer;

    constructor() {
        super();
        this.onResize();
        this.bgAnim = this.addChild(new SpinePlayer("BG"))
        this.bgAnim.position.set(360,360);
        this.onIdle(true);
    }

    public playPlusOneTextPos(pos:PIXI.Point, val: number, type?: string, cont?:PIXI.Container,size:number = 1): gsap.core.Timeline {
        let style:TextStyleOptions = this._multStyle;

        if (type && type[2] !== "3") {
            style = type[2] == "2" ? this._multStyle_GREEN : this._multStyle_RED;
        }

        const txt: PIXI.Text = cont ? cont.addChild(new PIXI.Text("+" + val, style)) : this.addChild(new PIXI.Text("+" + val, style));
        txt.zIndex = 5000;
        this.sortChildren();

        const startPos: PIXI.Point = pos;
        const heightYDirr: number = 60;

        txt.alpha = 0;
      
        txt.position = startPos;
        txt.anchor = new PIXI.Point(0.5, 0.25);

        const up: number = startPos.y - heightYDirr;

        const moveDurr: number = 0.5;
        const scaleDurr: number = 0.2;
        const alphaDurr: number = 0.15;

        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            onComplete: () => { if(txt && txt.transform) txt.destroy({ children: true }) }
        });

        tl.to(txt, { alpha: 1, duration: alphaDurr, ease:Power3.easeIn }, 0);
        tl.to(txt, { y: up, duration: moveDurr*0.75 }, 0);
        tl.fromTo(txt.scale, { x: 0.35, y: 0.35 }, { x: 1, y: 1, duration: scaleDurr }, 0);

        tl.to(txt, { y: startPos.y+heightYDirr*0.75, duration: moveDurr, ease: Power3.easeIn }, moveDurr*0.75);

        tl.to(txt, { duration: alphaDurr, alpha: 0 }, "-="+alphaDurr)

        return tl;
    }

    public playPlusOneText(target: PIXI.DisplayObject, val: number, type?: string, isBitMap?:boolean): gsap.core.Timeline {

        let style:TextStyleOptions = this._multStyle;

        if (type && type[2] !== "3") {
            style = type[2] == "2" ? this._multStyle_GREEN : this._multStyle_RED;
        }

        const txt: PIXI.Text | PIXI.BitmapText = this.addChild(isBitMap ? new PIXI.BitmapText("+" + val, this._styleFS) : new PIXI.Text("+" + val, style));
        txt.zIndex = 5000;
        this.sortChildren();

        const startPos: PIXI.Point = Helper.copyLocalPosition(txt, target)
        const heightYDirr: number = 60;

        txt.alpha = 0;
      
        txt.position = startPos;
        txt.anchor = new PIXI.Point(0.5, 0.4);

        const up: number = startPos.y - heightYDirr;

        const moveDurr: number = 0.5;
        const scaleDurr: number = 0.2;
        const alphaDurr: number = 0.15;

        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            onComplete: () => { if(txt && txt.transform) txt.destroy({ children: true }) }
        });

        tl.to(txt, { alpha: 1, duration: alphaDurr, ease:Power3.easeIn }, 0);
        tl.to(txt, { y: up, duration: moveDurr*0.75 }, 0);
        tl.fromTo(txt.scale, { x: 0.35, y: 0.35 }, { x: 1, y: 1, duration: scaleDurr }, 0);

        tl.to(txt, { y: startPos.y+heightYDirr*0.75, duration: moveDurr, ease: Power3.easeIn }, moveDurr*0.75);

        tl.to(txt, { duration: alphaDurr, alpha: 0 }, "-="+alphaDurr)

        return tl;
    }

    public playValueText(target: PIXI.DisplayObject, val: number,waysValue:number): gsap.core.Timeline {

        const currValue:string  = SlotGame.apiPlugin.currency.formatValue(val)
        const txt: PIXI.Text | PIXI.BitmapText = this.addChild(new PIXI.BitmapText(currValue, this._style_low));
        txt.anchor = new PIXI.Point(0.5, 0.4);

        const txtWays = this.addChild(new PIXI.Text(""));
        txtWays.style = this._styleWays;
        txtWays.anchor.set(0.5, 0.4);
        txtWays.pivot.y = -60;
        txtWays.text = waysValue.toString() + " " + Translator.translate((waysValue == 1 ? TranslationTexts.WAY_WON : TranslationTexts.WAYS_WON));
        txtWays.updateTransform();

        txt.zIndex = 5000;
        this.sortChildren();

        const startPos: PIXI.Point = Helper.copyLocalPosition(txt, target)
        const heightYDirr: number = 60;

        txt.alpha = 0;
        txtWays.alpha = 0;
      
        txt.position = startPos;
        txtWays.position = startPos;

        const up: number = startPos.y - heightYDirr;

        const moveDurr: number = 0.7;
        const scaleDurr: number = 0.3;
        const alphaDurr: number = 0.25;

        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            onComplete: () => { 
                if(txt && txt.transform) txt.destroy({ children: true });
                if(txtWays && txtWays.transform) txtWays.destroy({ children: true });
            }
        });

        const animate:PIXI.DisplayObject[] = [txt,txtWays];

        tl.to(animate, { alpha: 1, duration: alphaDurr, ease:Power3.easeIn }, 0);
        tl.to(animate, { y: up, duration: moveDurr*0.75 }, 0);
        animate.forEach(item => {
            tl.fromTo(item.scale, { x: 0.35, y: 0.35 }, { x: 1, y: 1, duration: scaleDurr }, 0);
        })
        tl.to(animate, { duration: alphaDurr, alpha: 0 }, "-="+alphaDurr)
        return tl;
    }

    public playPlusBox(target: PIXI.DisplayObject, boxTarget:PIXI.DisplayObject, val: number, isMult:boolean,type:string): gsap.core.Timeline {

        const texturePath:string = fetchTexturePath(type,isMult);

        const txt: PIXI.Text | PIXI.BitmapText = this.addChild(new PIXI.BitmapText("+" + val, this._style));
        const sp:PIXI.Sprite = this.addChild(new PIXI.Sprite(RoadRage.assetLoader.getTextures(texturePath)[0]))
        txt.zIndex = 5001;
        sp.zIndex = 5000;
        this.sortChildren();

        const startPos: PIXI.Point = Helper.copyLocalPosition(sp, target);
        
        const heightYDirr: number = 60;

        sp.alpha = 0;
      
        txt.position = sp.position = startPos;

        txt.anchor = sp.anchor = new PIXI.Point(0.5, 0.5);

        const up: number = startPos.y - heightYDirr;
        txt.visible = val > 1;

        const moveDurr: number = 1;
        const scaleDurr: number = 0.3;
        const alphaDurr: number = 0.15;

        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            onComplete: () => { sp.destroy({ children: true }); txt.destroy({ children: true }); } 
        });


        tl.fromTo([txt,sp], {alpha:0}, { alpha: 1, duration: alphaDurr, ease:Power3.easeIn }, 0);
        tl.to([txt,sp], { y: up, duration: moveDurr*0.75 }, 0);

        tl.fromTo([txt.scale, sp.scale], { x: 0.35, y: 0.35 }, {  x: isMult ? 0.75 : 0.6, y: isMult ? 0.75 : 0.6, duration: scaleDurr }, 0);

        tl.to([txt,sp], { duration: .5, alpha: 0 }, 0.75)

        return tl;
        

        function fetchTexturePath(type:string,isMult:boolean):string{
            if(isMult){
                switch(type){
                    case "WC1":
                        return "Wheel_Icon_C"
                        break;
                    case "WC2":
                        return "Wheel_Icon_A"
                        break;
                    default:
                        return "Wheel_Icon_B"
                }
            }else{
                switch(type){
                    case "WC1":
                        return "Wild_Assets/144/Car_1"
                        break;
                    case "WC2":
                        return "Wild_Assets/144/Car_2"
                        break;
                    default:
                        return "Wild_Assets/144/Car_3"
                }
            }
        }
    }

    private idleTL:gsap.core.Timeline;
    public onIdle(active:Boolean):void{

        if(active && this.idleTL && this.idleTL.isActive()) return;
        
        this.idleTL = Helper.setTimeline(this.idleTL,  new gsap.core.Timeline({repeat: active ? -1 : 0}))

        if(active){
            this.idleTL.to(this,{duration:7.5})
            this.idleTL.add(() => { 
                this.bgAnim.position.set(360,360);
                this.bgAnim.scale.x = Math.random() > 0.5 ? 1 : -1;
                const animName = ["BG_Idle", "BG_Idle_2" ,"BG_Idle_3"][MathHelper.randomIntInRange(0,2)];
                this.bgAnim.play({animation:animName });
            })
        }
    }


    public playMapSwitch(): void {

        const seq:Sequence = this.addChild(new Sequence({texturePath:"FX_Speedlines"}))
        seq.scale.set(4)
        seq.anchor.set(0.5);
        seq.play({duration :0.75, repeat:-1})
        seq.position.set(360,360);
        seq.blendMode = BLEND_MODES.ADD;

        const tl: gsap.core.Timeline = new gsap.core.Timeline({onComplete:() => { seq.stop(),seq.destroy({children:true})}});

        tl.fromTo(seq,{alpha:0},{alpha:1,duration:0.5},0)
        tl.to(seq,{alpha:0, duration:0.25},0.5)
    }

    public playPlusOneFS(target: PIXI.DisplayObject, val: number,scaling:boolean = true): gsap.core.Timeline {

        const txt: PIXI.Text | PIXI.BitmapText = this.addChild(new PIXI.BitmapText("+" + val, this._style));
        txt.zIndex = 5000;
        this.sortChildren();

        const startPos: PIXI.Point = Helper.copyLocalPosition(txt, target)
        const heightYDirr: number = 60;

        txt.alpha = 0;
      
        txt.position = startPos;
        txt.anchor = new PIXI.Point(0.5, 0.4);

        const up: number = startPos.y - heightYDirr;

        const moveDurr: number = 1;
        const scaleDurr: number = 0.2;
        const alphaDurr: number = 0.15;

        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            onComplete: () => { if(txt && txt.transform) txt.destroy({ children: true }) }
        });

        tl.fromTo([txt], {alpha:0}, { alpha: 1, duration: alphaDurr, ease:Power3.easeIn }, 0);
        tl.to([txt], { y: up, duration: moveDurr*0.75 }, 0);

        tl.fromTo(txt.scale, { x: 0.35, y: 0.35 }, { x: 1, y: 1, duration: scaleDurr }, 0);

        tl.to([txt], { duration: .5, alpha: 0 }, 0.75)

        return tl;
    }

    private createGraphic(sizeX: number = 100, sizeY?: number, color?: number): PIXI.Graphics {
        if (!sizeY) sizeY = sizeX;
        const gfx: PIXI.Graphics = this.addChild(new PIXI.Graphics());
        gfx.clear();
        gfx.beginFill(color != undefined ? color : 0xFFFFFF, 1);
        gfx.drawRect(-sizeX * 0.5, -sizeY * 0.5, sizeX, sizeY);
        gfx.endFill();
        return gfx;
    }

    public playStandAloneSequence(texture: PIXI.Texture[], conf: ISequencePlay = {}, layer?: PIXI.Container): OverlayItem {
        const item: Sequence = layer ? layer.addChild(Sequence.createSequence(texture)) : this.addChild(Sequence.createSequence(texture));

        const tl: gsap.core.Timeline = Helper.temporaryItemTl(item);

        tl.add(item.play(conf));

        return { item: item, timeline: tl };
    }

    public addChild<TChildren extends PIXI.DisplayObject[]>(...child: TChildren): TChildren[0] {
        super.addChild(...child);
        this.sortChildren();
        return child[0];
    }

    public playStandAloneSpine(path: string, conf: SpinePlayConfig, layer?: PIXI.Container): OverlayItem {
        const item: SpinePlayer = layer ? layer.addChild(new SpinePlayer(path)) : this.addChild(new SpinePlayer(path))
        const tl: gsap.core.Timeline = Helper.temporaryItemTl(item);

        tl.add(item.play(conf));

        return { item: item, timeline: tl };
    }

    public playSpine(target: PIXI.DisplayObject, path: string, conf: SpinePlayConfig, stay: boolean = false, cont?: PIXI.Container, initVisible:boolean = true): OverlayItem {
        const item: SpinePlayer = cont ? cont.addChild(new SpinePlayer(path, initVisible)) : this.addChild(new SpinePlayer(path, initVisible))
        const tl: gsap.core.Timeline = stay ? new gsap.core.Timeline({
            onUpdate: () => {
                if (target) {
                    item.position = Helper.copyLocalPosition(item, target)
                } else {
                    tl.kill();
                    item.destroy();
                }
                conf.onUpdate ? conf.onUpdate() : undefined;
            }
        }) : this.createItemTlToFollow(target, item);

        item.position = Helper.copyLocalPosition(item, target)
        tl.add(item.play(conf));

        return { item: item, timeline: tl };
    }

    public playSequence(target: PIXI.DisplayObject, texture: PIXI.Texture[], conf: ISequencePlay = {}, layer?: PIXI.Container): OverlayItem {
        const item: Sequence = layer ? layer.addChild(Sequence.createSequence(texture)) : this.addChild(Sequence.createSequence(texture));

        const tl: gsap.core.Timeline = this.createItemTlToFollow(target, item);

        tl.add(item.play(conf));

        return { item: item, timeline: tl };
    }

    public flashGFX(target: PIXI.DisplayObject, sizeX?: number, sizeY?: number, durr: number = 0.5, color?: number): OverlayItem {

        const item: PIXI.DisplayObject = this.createGraphic(sizeX, sizeY, color);

        const tl: gsap.core.Timeline = this.createItemTlToFollow(target, item);

        tl.fromTo(item, { alpha: 0 }, { alpha: 1, duration: durr / 2 });
        tl.to(item, { alpha: 0, duration: durr / 2 });
        return { item: item, timeline: tl };
    }

    public useItemAsOverlay(target: PIXI.DisplayObject, item: PIXI.DisplayObject): OverlayItem {
        const tl: gsap.core.Timeline = this.createItemTlToFollow(target, item);
        this.addChild(item);
        return { item: item, timeline: tl };
    }

    private createItemTlToFollow(target: PIXI.DisplayObject, item: PIXI.DisplayObject): gsap.core.Timeline {
        const tl = new gsap.core.Timeline({
            onUpdate: () => {
                if (!target || !target.parent) {
                    remove();
                } else if (item.transform) {
                    item.position = Helper.copyLocalPosition(item, target)
                }
            },
            onComplete: () => remove()
        });

        item.position = Helper.copyLocalPosition(item, target)

        function remove() {
            tl.kill();
            item.transform && item.destroy();
            target = undefined!;
        }

        return tl;
    }

    public moveCarOnOverlay(moveFromLeft:boolean,yPos:number,carType:string):gsap.core.Timeline{

        const tempCarTrail = RoadRage.overlayAnim.addChild(new PIXI.Sprite(RoadRage.assetLoader.getTextures("Cars_Trails/"+carType+"_Trail")[0]))
        const tempCar = RoadRage.overlayAnim.addChild(new PIXI.Sprite(RoadRage.assetLoader.getTextures(carType+"/144/"+carType)[0]));

        tempCar.anchor.set(0.5,0.5);
        tempCar.scale.x = carType === "WC2" ?  -1 : 1;
        tempCarTrail.anchor.set(carType === "WC2" ? 0.4 : 0, 0.5);
        tempCarTrail.position = tempCar.position;
        tempCarTrail.scale = tempCar.scale;

        tempCarTrail.alpha = 0.15;

        const animToMove:PIXI.Sprite[] = [tempCar,tempCarTrail];

        const tl:gsap.core.Timeline = new gsap.core.Timeline({onComplete:() => {
            tempCar.destroy();
            tempCarTrail.destroy();
        }});
        360
        const startPos:PIXI.Point = new PIXI.Point(moveFromLeft ? -1080 : 1080 + 360, yPos);
        const endPos:PIXI.Point = new PIXI.Point(moveFromLeft ? 1080*2 : -1080*2 + 360, yPos);

        tl.fromTo(animToMove, { x: startPos.x,y:startPos.y} ,{x:endPos.x, duration: 2,y:endPos.y}, 0);

        return tl;
    }

    public removeNonUsedAnimations(): void {
        this.children.forEach(s => { if (s.name != "mask") s.destroy() });
    }

    public onResize(): void {
        this.scale = RoadRageEngineManager.dim.scale;
    }
}